import { render, staticRenderFns } from "./CompEdit.vue?vue&type=template&id=d513dffa&scoped=true"
import script from "./CompEdit.vue?vue&type=script&lang=js"
export * from "./CompEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d513dffa",
  null
  
)

export default component.exports